import moment from 'moment'
import { findIndex, isEmpty } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'

export const initialNewData = (tableData) => {
  const numberOfInstallmentIndex = !isEmpty(tableData) ? tableData.length : 0

  return {
    numberOfInstallment: numberOfInstallmentIndex + 1,
    id: tableData[numberOfInstallmentIndex]?.id || null,
    organizationTypeName: 2,
    organizationNameOther: tableData[numberOfInstallmentIndex]?.organizationNameOther || null,
    projectCode: tableData[numberOfInstallmentIndex]?.projectCode || null,
    projectName: tableData[numberOfInstallmentIndex]?.projectName || null,
    projectEndDate: tableData[numberOfInstallmentIndex]?.projectEndDate
      ? moment(tableData[numberOfInstallmentIndex]?.projectEndDate, 'DD/MM/YYYY')
          .toDate()
          .toLocaleDateString('en-ZA')
      : null,
    responsiblePercent: tableData[numberOfInstallmentIndex]?.responsiblePercent || null,
    isDeletable: true,
    status: 'EDIT',
    makeId: uuidv4(),
  }
}

export const getExpandedId = (_data) => {
  if (isEmpty(_data)) {
    return
  }
  let detailIds = []

  return [...detailIds]
}

export const getNewDataEdit = (tableData, rowData) => {
  const nextData = Object.assign([], tableData)
  const index = findIndex(nextData, { id: rowData.id })
  const activeItem = nextData[index]
  activeItem.isDeletable = true
  activeItem.status = activeItem.status ? null : 'EDIT'

  return nextData
}
